export const VALIDATE_COUPON = 'VALIDATE_COUPON';